import tags from './helpers/tags'
import games from './helpers/games'

import _ from 'underscore'

export default {

	namespaced: true,

	state: {

		data: []

	},

	getters: {

		count: function(state) {

			return state.data.length

		},

		list: function(state) {

			return state.data

		},

		associated: function(state) {

			var associated = {}

			_.each(state.data, function(item) {

				associated[item.id] = item

			})

			return associated

		},

		'associated/games': function(state) {

			var associated = {}

			_.each(state.data, function(item) {

				associated[item.game.id] = item

			})

			return associated

		},

		'associated/games/all': function(state) {

			var associated = {}

			_.each(state.data, function(item) {

				associated[item.game.id] = item

			})

			return associated

		},

		'associated/raw': function(state) {

			var associated = {}

			_.each(state.data, function(item) {

				associated[item.id] = item

			})

			return associated

		}

	},

	mutations: {

		'tags/clear': tags.clear,
		'tags/remove': tags.remove,
		'tags/add': tags.add,
		'tags/toggle': tags.toggle,

		'games/rename': games.rename,

		reset: function(state) {

			state.data = []

		},

		set: function(state, data) {

			state.data = data

		},

		append: function(state, items) {

			var list = []

			_.each(state.data, function(item) {

				list.push(item)

			})

			_.each(items, function(item) {

				list.push(item)

			})

			state.data = list

		},

		push: function(state, item) {

			state.data.push(item)

		}

	},

	actions: {}

}